<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="party.isNew()" content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(party.id)"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="party" :rules="rules" :wrapper-col="{span:16}">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.no')" prop="no">
              <vxe-input v-model="party.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.name')" prop="name">
              <vxe-input v-model="party.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.mnemonicCode')">
              <vxe-input v-model="party.mnemonicCode" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.shortName')">
              <vxe-input v-model="party.shortName" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type>1" :span="6">
            <a-form-model-item :label="$t('business.label.owner')">
              <vxe-select v-model="ownerIds" :options="owners" multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type>1" span="6">
            <a-form-model-item :label="$t('business.label.classification')">
              <vxe-select v-model="party.classification.id" :options="classifications" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type>1" span="6">
            <a-form-model-item :label="$t('business.label.regions')">
              <vxe-select v-model="party.region.id" :disabled="type!==3" :options="regions" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.dataSource')">
              <vxe-select v-model="party.dataSource" :options="dataSources" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.turnoverMode')">
              <vxe-select v-model="party.turnoverMode" :disabled="type!==3" :options="turnoverModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfLot')">
              <vxe-number-input v-model="party.numberOfLot" :disabled="type!==3" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.separationOfLabel')">
              <vxe-number-input v-model="party.separationOfLabel" :disabled="type!==3" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type>1" span="6">
            <a-form-model-item :label="$t('business.label.pickupMode')" prop="pickupMode">
              <vxe-select v-model="party.pickupMode.id" :disabled="type!==3" :options="pickupModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col v-if="type===2" span="3">
            <a-form-model-item :label="$t('business.label.autoAccepting')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="party.autoAccepting"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===2" span="3">
            <a-form-model-item :label="$t('business.label.autoPutaway')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="party.autoPutaway"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===3" span="3">
            <a-form-model-item :label="$t('business.label.autoPrint')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="party.autoPrint"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===3" span="3">
            <a-form-model-item :label="$t('business.label.mergeOrder')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="party.mergeOrder"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===3" span="3">
            <a-form-model-item :label="$t('business.label.reserveOnly')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="party.reserveOnly"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <address-detail ref="addressDetail" @change="onAddressChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Party } from '@/api/dto/common/Party'
import AddressDetail from '@/views/basedata/address/AddressDetail.vue'

export default {
  name: 'PartyDetail',
  components: { AddressDetail },
  props: {
    type: { type: Number, default: null },
    partyTypes: { type: Array, default: [] },
    classifications: { type: Array, default: [] },
    regions: { type: Array, default: [] },
    dataSources: { type: Array, default: [] },
    turnoverModes: { type: Array, default: [] },
    pickupModes: { type: Array, default: [] },
    owners: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      enterprise: Vue.ls.get(ENTERPRISE),
      party: new Party(),
      typeIds: [],
      ownerIds: [],
      rules: {
        no: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        pickupMode: [{ required: this.type === 3, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    onAddressChange(value) {
      this.party.address = value
    },
    build(result) {
      this.party = new Party(result)
      this.typeIds = result && result.types ? result.types.map(item => item.id) : []
      this.ownerIds = result && result.owners ? result.owners.map(item => item.id) : []
      if (!this.party.address.isNew()) this.$refs.addressDetail.refresh(this.party.address.id)
    },
    refresh(id, copy) {
      this.loading = true
      findOne('partyFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.build(res.result)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.build()
      this.party.available = true
      this.party.approved = true
      this.party.dataSource = 4
      this.typeIds = [this.partyTypes.find(item => item.ordinal === this.type)?.value]
      this.ownerIds = []
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const party = this.party.toJSONObject()
          party.enterprise = this.enterprise
          party.types = this.typeIds ? this.typeIds.map(item => {
            return { id: item }
          }) : []
          party.owners = this.ownerIds ? this.ownerIds.map(item => {
            return { id: item }
          }) : []
          save('partyPersister', party).then(res => {
            if (res.success) {
              this.build(res.result)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>